import { useCallback } from 'react';
import { useResource } from 'hooks/useResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const useAccount = (accountId) => {
	const fetchFn = useCallback(async () => {
		if (!accountId) return null;
		return await salesforceAccountsService.getAccount(accountId);
	}, [accountId]);

	const { data, loading, error, refetch } = useResource({ fetchFn });

	return {
		account: data || null,
		loading,
		error,
		refetch,
	};
};

export default useAccount;
